import script from "./GlobalNavigationProgress.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalNavigationProgress.vue?vue&type=script&setup=true&lang=ts"

import "./GlobalNavigationProgress.vue?vue&type=style&index=0&id=6b6b7451&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b6b7451"]])

export default __exports__